<template>
  <div class="side server-list-mod">
    <div class="h-tt">
      <h2>服务器列表</h2>
    </div>
    <div class="box">
      <div class="server-fast">
        <span>快速选择区服</span>
        <input
          v-model="serverId"
          type="number"
          min="1"
          class="server-fast-ipt"
        />
        <a
          href="javascript:;"
          class="server-fast-btn"
          @click="
            goServer('KSXF', '快速选服', { server_code: serverId })
            reportClick('enter', serverId)
          "
        >
          进入
        </a>
      </div>
      <ul class="scrollbar">
        <li
          v-for="(item, index) in $store.state.game.serverList"
          :key="item.server_id"
        >
          <a
            href="javascript:;"
            @click="
              goServer(`FWQLB${index + 1}`, `服务器列表${index + 1}`, {
                server_id: item.server_id
              })
              reportItemClick(item.server_id, item.tag || 'none')
            "
          >
            <span class="game-name">{{ $store.state.game.info.title }}</span>
            <span class="server-name">{{ item.title }}</span>
            <span
              v-if="
                ($util.flagName(item.flag) === '新开' ||
                  $util.flagName(item.flag) === '火爆' ||
                  $util.flagName(item.flag) === '开启') &&
                  index === 0
              "
              class="game-tab game-tab1 open"
            >
              新服
            </span>
            <span
              v-else-if="
                ($util.flagName(item.flag) === '新开' ||
                  $util.flagName(item.flag) === '火爆' ||
                  $util.flagName(item.flag) === '开启') &&
                  index > 0 &&
                  index < 6
              "
              class="game-tab game-tab1 hot"
            >
              火爆
            </span>
            <span
              v-else-if="$util.flagName(item.flag) === '关闭'"
              class="game-tab game-tab1 close"
            >
              关闭
            </span>
            <span
              v-else-if="$util.flagName(item.flag) === '维护'"
              class="game-tab game-tab1 maintain"
            >
              维护
            </span>
          </a>
        </li>
      </ul>
      <a
        :href="`/game-offical/${$route.params.game_id}/server-list-update/`"
        class="server-more-btn"
        target="_blank"
      >
        查看更多服务器
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    xla: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      serverId: 1
    }
  },
  mounted() {
    this.$xlaGamePush(this.xla.show)
  },
  methods: {
    reportClick(click_id, channel) {
      this.$xlaGamePush(this.xla.click, {
        game_id: this.$route.params.game_id,
        channel,
        click_id
      })
    },
    reportItemClick(channel, tag) {
      this.$xlaGamePush(this.xla.itemClick, {
        game_id: this.$route.params.game_id,
        channel,
        tag
      })
    },
    goServer(eid, eid_desc, query) {
      const server_code = query.server_code || 0
      let server_id = query.server_id || 0
      if (server_code) {
        const serverList = this.$store.state.game.serverList
        for (const item of serverList) {
          if (Number(item.server_num) === Number(server_code)) {
            server_id = item.server_id
            break
          }
        }
      }
      this.$util.gameStat(
        this.$route.params.game_id,
        server_id,
        `${this.$route.params.game_id}/GW/SY/${eid}`,
        `${this.$route.params.game_id}/官网/首页/${eid_desc}`,
        server_code
      )
    }
  }
}
</script>
